module.exports = __webpack_public_path__ + "img/cleanWaterAndSanitation.553fdba9.png";